import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../../colorVars';
import { Dropdown } from '../../../../../../../atomic/atomicComponentLibrary/dropdown/Dropdown';
import { NumericalInput } from '../../../../../../../atomic/atomicComponentLibrary/numericalInput/NumericalInput';
import { Body3, Body4, fontSizes } from '../../../../../../../atomic/text/Text';
import style from '../SimpleTacticStyle.module.css';

type Props = {
  candleDuration: number;
  timeUnit: string;
};

export const SimpleCandleTrail = observer(
  ({ candleDuration, timeUnit }: Props) => {
    const tradePlanForm: TradePlanData = useTradePlanFormStore();
    const defaultFn = () => {};
    const isEnabled = tradePlanForm.exitTactics.CANDLE_TRAIL ?? false;
    const candleDurationValue =
      tradePlanForm.exitTactics.CANDLE_TRAIL?.candleDuration ?? 1;
    const setCandleDurationValue =
      tradePlanForm.exitTactics.CANDLE_TRAIL?.setCandleDuration ?? defaultFn;
    const timeUnitValue = tradePlanForm.exitTactics.CANDLE_TRAIL?.timeUnit ?? 1;
    const setTimeUnitValue =
      tradePlanForm.exitTactics.CANDLE_TRAIL?.setTimeUnit ?? defaultFn;

    return (
      <div className={style.container}>
        <div className={style.labelAndCheckbox}>
          <input
            style={{ margin: '0 5px 0 0' }}
            type="checkbox"
            checked={isEnabled}
            onChange={() => {
              if (isEnabled) {
                tradePlanForm.removeExitTactic('CANDLE_TRAIL');
              } else {
                tradePlanForm.addExitTactic('CANDLE_TRAIL', {
                  candleDuration,
                  timeUnit,
                });
              }
            }}
          />
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Candle Trail
          </Body3>
        </div>
        <div className={style.controls}>
          <div className={style.labelAndControl}>
            <Body4 color={colors.lightGrey}>Candle Duration</Body4>
            <NumericalInput
              disabled={!isEnabled}
              width="50px"
              maxHeight="23px"
              fontSize={fontSizes.body4}
              fontColor="white"
              backgroundColor="grey"
              controlledValue={candleDurationValue}
              onChange={setCandleDurationValue}
            />
          </div>
          <div className={style.labelAndControl}>
            <Body4 color={colors.lightGrey}>Time Unit</Body4>
            <Dropdown
              fontSize={fontSizes.body4}
              color="white"
              backgroundColor="grey"
              value={timeUnitValue}
              onChange={setTimeUnitValue}
            >
              <option value="MINUTES">Minutes</option>
              <option value="DAYS">Days</option>
              <option value="WEEKS">Weeks</option>
              <option value="MONTHS">Months</option>
              <option value="QUARTERS">Quarters</option>
              <option value="YEARS">Years</option>
            </Dropdown>
          </div>
        </div>
      </div>
    );
  }
);
